/**
 * Status → label/tone map for affiliate commission periods.
 * Keep labels aligned with todo/eng/eng-00099/implementation-spec.md.
 */

export const AFFILIATE_PAYOUT_STATUS_META = {
  estimated: { label: "Estimated", tone: "neutral" },
  pending_setup: { label: "Pending setup", tone: "warning" },
  on_hold: { label: "On hold (14 days)", tone: "info" },
  pending_approval: { label: "Pending approval", tone: "info" },
  queued_for_payout: { label: "Processing payout", tone: "info" },
  completed: { label: "Paid", tone: "success" },
  failed: { label: "Failed", tone: "danger" },
  rejected: { label: "Rejected", tone: "danger" },
  reversed: { label: "Reversed", tone: "neutral" },
};

export const getAffiliatePayoutStatusMeta = (status) => {
  const key = String(status || "").trim();
  return AFFILIATE_PAYOUT_STATUS_META[key] || { label: key || "Unknown", tone: "neutral" };
};

/** Alias used by MyPaymentsPage (eng-00099 affiliate unit). */
export const getPayoutStatusMeta = getAffiliatePayoutStatusMeta;

export const payoutStatusBadgeClasses = (tone) => {
  switch (tone) {
    case "success":
      return "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-200";
    case "danger":
      return "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-200";
    case "warning":
      return "bg-amber-100 text-amber-900 dark:bg-amber-900/40 dark:text-amber-100";
    case "info":
      return "bg-sky-100 text-sky-800 dark:bg-sky-900/40 dark:text-sky-200";
    default:
      return "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-200";
  }
};

/** Convenience: status -> badge class string (used by MyPaymentsPage). */
export const getPayoutStatusBadgeClasses = (status) => {
  const meta = getAffiliatePayoutStatusMeta(status);
  return `inline-flex px-2 py-0.5 rounded-md text-xs font-medium ${payoutStatusBadgeClasses(meta.tone)}`;
};
